import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useProcessApiClient } from '@/api/clients/useProcessApiClient.util.ts';
import { ResourceIdDto } from '@/api/generated';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = {
  resource: ResourceIdDto;
};

type Response = void;

type Return = {
  isMarking: boolean;
  markResourceMessagesAsSeen: (req: Req) => Promise<Response>;
};

export const useMarkResourceMessagesAsRead = (): Return => {
  const { resourceTimelineMessagesApi } = useProcessApiClient();
  const { userId } = useUserContext();

  const { isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    mutationFn: async req => {
      await resourceTimelineMessagesApi.markAsSeen(
        req.resource.resourceId,
        req.resource.type,
        userId,
      );
    },
  });

  return {
    isMarking: isPending,
    markResourceMessagesAsSeen: mutateAsync,
  };
};
